import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-9 d-flex align-items-center" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "row mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_5 = { class: "col d-flex align-items-center" }
const _hoisted_6 = { class: "text-muted align-middle mb-0" }

import { ref, computed } from "vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import HelpText from "@/guiide/ts/helpText";
import ThreeDotMenu from "@/guiide/components/common/ThreeDotMenu.vue";
import AddAsset from "@/guiide/components/assets/AddAsset.vue";
import EmptyAsset from "@/guiide/components/assets/EmptyAsset.vue";
import Modal from "@/guiide/components/common/Modal.vue";
import OtherCashEditor from "@/guiide/components/assets/OtherCashEditor.vue";
import ObjectBuilder from "@/guiide/ts/objectBuilder";
import Constants from "@/guiide/ts/constants";
import { app } from "@/guiide/ts/app";
import { OtherCash } from "@/guiide/ts/otherCash";
import TemporalDetail from "@/guiide/ts/temporalDetail";
import { getPermissionSet } from "@/guiide/ts/utilities";
import { useStore } from "vuex";
import CashType from "@/guiide/ts/cashType";
import View from "@/guiide/ts/view";


export default /*@__PURE__*/_defineComponent({
  __name: 'OtherCashViewer',
  setup(__props) {

const store = useStore();

const assetModal = ref(null);
const assetEditor = ref(null);
const modalTitle = ref("Edit other cash");

const addAssetButton = ref<HTMLElement>(null);
const addAssetComponent = ref<InstanceType<typeof AddAsset> | null>(null);

const getOtherCash = computed<Array<OtherCash>>(() => {
  return store.state.retiree?.otherCash ?? new Array<OtherCash>();
});

const hasOtherCash = computed<boolean>(() => getOtherCash.value.length > 0);

function onAdd() {
  modalTitle.value = "Add other cash";
  const defaultReceiptDate = TemporalDetail.getOtherCashDefaultReceiptDate();
  const incrementMonthIndexToAlignWithIncorrectIndexingInMonthYearComponent = defaultReceiptDate.getMonth() + 1;
  const otherCashAsset = ObjectBuilder.createOtherCash(
    Constants.NewId,
    "",
    0,
    incrementMonthIndexToAlignWithIncorrectIndexingInMonthYearComponent,
    defaultReceiptDate.getFullYear()
  );
  assetEditor.value.setValues(otherCashAsset);

  addAssetButton.value = addAssetComponent.value.getAddButton();

  assetModal.value.showModal();
}

function onEdit(id: number) {
  modalTitle.value = "Edit other cash";
  const otherCash = getOtherCash.value.filter(p => p.id == id)[0];
  assetEditor.value.setValues(otherCash);
  assetModal.value.showModal();
}

async function onDelete(id: number) {
  await app.deleteOtherCash(id);
}

function onEditFinished() {
  assetModal.value.closeModal();
}

const showEquityReleaseDashboardPrompt = computed<boolean>(() => getOtherCash.value.some(c => c.cashType == CashType.EquityRelease));

const equityReleasePromptLocationPostfix = computed<string>(() => {
  return store.state.view == View.Haves ? " in the Dashboard" : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SubSection, {
      title: "Other cash",
      helpTitle: "Other cash",
      helpText: _unref(HelpText).otherCash()
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOtherCash.value, (otherCash) => {
          return (_openBlock(), _createElementBlock("div", {
            key: otherCash.id,
            class: "row mb-2"
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(otherCash.description), 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ThreeDotMenu, {
                id: otherCash.id,
                permissions: _unref(getPermissionSet)(otherCash.editMode, false, true, true),
                "aria-purpose": otherCash.name,
                onEditClicked: onEdit,
                onDeleteClicked: onDelete
              }, null, 8, ["id", "permissions", "aria-purpose"])
            ])
          ]))
        }), 128)),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(EmptyAsset, { name: "cash" })
        ], 512), [
          [_vShow, !hasOtherCash.value]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AddAsset, {
            name: "cash",
            longName: "any other cash",
            onAddClicked: _cache[0] || (_cache[0] = ($event: any) => (onAdd())),
            ref_key: "addAssetComponent",
            ref: addAssetComponent
          }, null, 512)
        ]),
        (showEquityReleaseDashboardPrompt.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, " If you wish to consider the Equity Release route further, check out the Equity Release page" + _toDisplayString(equityReleasePromptLocationPostfix.value) + ". ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["helpText"]),
    _createVNode(Modal, {
      title: modalTitle.value,
      ref_key: "assetModal",
      ref: assetModal,
      idKey: "otherCash",
      "close-button-aria-label": "Close other cash popup editor",
      returnFocusTo: addAssetButton.value
    }, {
      default: _withCtx(() => [
        _createVNode(OtherCashEditor, {
          ref_key: "assetEditor",
          ref: assetEditor,
          onEditFinished: onEditFinished
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title", "returnFocusTo"])
  ], 64))
}
}

})